import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const baseStyle = defineStyle({
  _light: {
    bg: 'white',
    color: 'black',
  },
  _dark: {
    bg: 'gray.200',
    color: 'white',
  },
})

export const SkipLink = defineStyleConfig({
  baseStyle,
})
